@import "~@govbr-ds/core/src/components/message/message";

:host {
  display: block;

  .icon-space {
    margin-right: var(--spacing-scale-half);
  }

  $br-message-color-map: (
    success: var(--success-rgb),
    danger: var(--danger-rgb),
    info: var(--info-rgb),
  );

  .br-message {
    .content .message-title {
      margin-right: 5px;
    }

    .close br-button {
      --interactive: var(--message-color-icon);
    }

    &.warning .close br-button {
      --interactive: var(--color);
      --interactive-rgb: var(--color-rgb);
    }

    @each $variant, $rgb in $br-message-color-map {
      &.#{$variant} .close br-button {
        --interactive-rgb: #{$rgb};
      }
    }
  }
}
